
<div class="relative">
    <!-- Left Arrow -->
    <button
      class="absolute left-0 top-0 p-2 bg-gray-900 text-white rounded-full shadow-lg hover:bg-gray-800 z-10 transition-opacity duration-200"
      (click)="scrollLeft()"
      *ngIf="canScrollLeft"
      aria-label="Scroll left"
    >
      &larr;
    </button>
  
    <!-- Right Arrow -->
    <button
      class="absolute right-0 top-0 p-2 bg-gray-900 text-white rounded-full shadow-lg hover:bg-gray-800 z-10 transition-opacity duration-200"
      (click)="scrollRight()"
      *ngIf="canScrollRight"
      aria-label="Scroll right"
    >
      &rarr;
    </button>
  </div>
  <br>
  <div class="relative flex items-center w-full">
    <!-- Categories Pills -->
    <div
      #scrollableContainer
      class="flex space-x-3 overflow-x-hidden no-scrollbar scroll-smooth py-2 w-full"
      (scroll)="checkScrollPosition()"
    >
    <!-- Clear/All Button - shows first -->
    <button
      class="px-4 py-2 whitespace-nowrap rounded-full focus:outline-none text-xs sm:text-sm font-medium transition-all duration-200 flex-shrink-0"
      [ngClass]="{
        'bg-gray-800 text-slate-200 shadow-md': !selectedEventType,
        'bg-red-100 text-red-700 hover:bg-red-200 border border-red-300': selectedEventType
      }"
      (click)="clearSelection()"
    >
      {{ selectedEventType ? '✕ Clear Filter' : 'All Events' }}
    </button>

    <!-- Category Pills -->
    <button
      *ngFor="let category of eventsTypes"
      class="px-4 py-2 whitespace-nowrap rounded-full focus:outline-none text-xs sm:text-sm font-medium transition-all duration-200 flex-shrink-0"
      [ngClass]="{
        'bg-gray-800 text-slate-200 shadow-md': selectedEventType === category.uid,
        'bg-gray-200 text-gray-800 hover:bg-gray-300': selectedEventType !== category.uid
      }"
      (click)="selectCategory(category)"
    >
      {{ category?.name }}
    </button>
    </div>



</div>

